import { toast } from "sonner";

const KEY = "bloq_invite_nudge_v1";

// Subtle, one-time nudge shown right after a user's first "win" (first tip sent or bloq joined):
// "invite a friend, you both get BLOQ+". Fires at most once ever, and slightly after the win toast.
export function maybeShowInviteNudge() {
  try {
    if (localStorage.getItem(KEY)) return;
    localStorage.setItem(KEY, "1");
  } catch {
    return;
  }
  setTimeout(() => {
    toast("Invite a friend — you both get 7 days of BLOQ+ free", {
      description: "Share your link and earn free BLOQ+ months.",
      duration: 9000,
      action: {
        label: "Invite",
        onClick: () => {
          window.location.href = "/app/referrals";
        },
      },
    });
  }, 1400);
}
